import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';
import ApexChart from "react-apexcharts";

import * as APIS from "../../utils/service";
import queryString from 'query-string';

// 팝업 컴포넌트
import MainPopup from '../main/MainPopup';
import NewCheckBox from '../../component/NewCheckBox';

export default function Workstat({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [memberinfos, setmemberinfos] = useState('');
    const [week, setweek] = useState(moment().subtract('0', 'week').day(0).format());

    const [popupShow, setpopupShow] = useState(false);
    const [popupTitle, setpopupTitle] = useState('');
    const [popupType, setpopupType] = useState(1);

    const [statlists, setstatlists] = useState([]); // 
    const [item_chk, setitem_chk] = useState(1); // 매물쪽 선택옵션
    const [customer_chk, setcustomer_chk] = useState(1); // 고객쪽 선택옵션

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        getlists();
    }, [week]);

    const getlists = () => {
        dispatch(loadingflas({ loading: true }));

        let weeks = week ? week : moment(week).subtract('0', 'week').day(1).format();
        console.log(weeks, moment(weeks).format('YYYY-MM-DD'));
        let sender = {
            weekstart: moment(weeks).format('YYYY-MM-DD'),
            weekend: moment(weeks).add(6, 'days').format('YYYY-MM-DD'),
            types: 'stat1'
        }
        //console.log("sendersendersender", sender);
        APIS.postData('/v1/compony/typedashbord', sender).then(({ data }) => {
            if (data) {
                const {
                    items, customers, blacks, componyblacks, mycomponymembers, allmembers, stayitemcklists, staycustomercklists,
                    company_news_lists, contract_lists, meetings, customeralls, crewlists, itembeforemonths, customerbeforemonths,
                    contractbeforemonths, fincustomers, realdatas, posdatas, statlists, companyUserCount, areaUserCount,
                    outsideCount
                } = data;
                if(statlists?.length > 0){
                    setstatlists(statlists);
                } else {
                    setstatlists([]);
                }
            }
        }).catch(({ response }) => {
            console.log(response);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    
    const checkNaN = (value) => {
        if (isNaN(value))
            return 0
        else
            return value
    }

    const lineChart = () => {
        let data1 = 0;
        let data2 = 0;
        let data3 = 0;
        let cusdata1 = 0;
        let cusdata2 = 0;
        let cusdata3 = 0;
        let companydata1 = 0;
        let companydata2 = 0;
        let companydata3 = 0;
        let companycusdata1 = 0;
        let companycusdata2 = 0;
        let companycusdata3 = 0;
        let companyTotal = 0;
        let areaTotal = 0;
        statlists?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1)?.map((x, i) => {
            data1 = checkNaN((data1 * 1) + (x?.newitemTotal)); //신규등록
            data2 = checkNaN((data2 * 1) + (x?.itemTotal)); //그주합산전체매물
            data3 = checkNaN((data3 * 1) + (x?.itemSatusTotal)); //그주합산전체 임장
            cusdata1 = checkNaN((cusdata1 * 1) + (x?.newcustomerTotal)); //신규등록고객
            cusdata2 = checkNaN((cusdata2 * 1) + (x?.customerTotal)); //그주합산전체고객
            cusdata3 = checkNaN((cusdata3 * 1) + (x?.customerStatusTotal)); //그주합산전체 미팅
            companyTotal = checkNaN(x?.companyUserCount);
            areaTotal = checkNaN(x?.areaUserCount);
        });
        statlists?.filter(item => item?.c_idx * 1 === memberinfos?.c_idx * 1)?.map((x, i) => {
            //console.log(x);
            companydata1 = checkNaN((companydata1 * 1) + (x?.newitemTotal)); //신규등록
            companydata2 = checkNaN((companydata2 * 1) + (x?.itemTotal)); //그주합산전체매물
            companydata3 = checkNaN((companydata3 * 1) + (x?.itemSatusTotal)); //그주합산전체 임장
            companycusdata1 = checkNaN((companycusdata1 * 1) + (x?.newcustomerTotal)); //신규등록고객
            companycusdata2 = checkNaN((companycusdata2 * 1) + (x?.customerTotal)); //그주합산전체고객
            companycusdata3 = checkNaN((companycusdata3 * 1) + (x?.customerStatusTotal)); //그주합산전체 미팅
        });
        return (
            <div className='main_popup_content' style={{ marginBottom: 8, padding: 0 }}>
                <div className='main_popup_list_container'>
                    <div style={{ width: 690 }}>
                        <div className='main_popup_check_box'>
                            <div className='main_popup_check_flex'>

                                <NewCheckBox
                                    title={'신규 접수 매물'}
                                    value={item_chk === 1}
                                    setValue={() => {
                                        setitem_chk(1);
                                    }}
                                />
                                <NewCheckBox
                                    title={'거래가능 매물'}
                                    value={item_chk === 2}
                                    setValue={() => {
                                        setitem_chk(2);
                                    }}
                                />
                                <NewCheckBox
                                    title={'임장 비율'}
                                    value={item_chk === 3}
                                    setValue={() => {
                                        setitem_chk(3);
                                    }}
                                />
                            </div>

                            <div className='main_popup_check_flex'>
                                <NewCheckBox
                                    type={'red'}
                                    title={'신규 접수 고객'}
                                    value={customer_chk === 1}
                                    setValue={() => {
                                        setcustomer_chk(1);
                                    }}
                                />
                                <NewCheckBox
                                    type={'red'}
                                    title={'거래가능 고객'}
                                    value={customer_chk === 2}
                                    setValue={() => {
                                        setcustomer_chk(2);
                                    }}
                                />
                                <NewCheckBox
                                    type={'red'}
                                    title={'미팅 비율'}
                                    value={customer_chk === 3}
                                    setValue={() => {
                                        setcustomer_chk(3);
                                    }}
                                />
                            </div>
                        </div>

                        {/* <Line options={options} data={data} /> */}

                        <ApexChart
                            type="line"
                            //{companydata2/companyCount}={companydata2/areaCount}
                            series={[
                                {
                                    name: item_chk === 1 ? "신규 접수 매물" : item_chk === 2 ? "거래가능 매물" : "임장 비율",
                                    data: item_chk === 1 ? [data1, checkNaN(companydata1 / companyTotal).toFixed(1), checkNaN(companydata1 / areaTotal).toFixed(1)] :
                                        item_chk === 2 ? [data1, checkNaN(companydata2 / companyTotal).toFixed(1), checkNaN(companydata2 / areaTotal).toFixed(1)] :
                                            [data1, checkNaN(companydata3 / companyTotal).toFixed(1), checkNaN(companydata3 / areaTotal).toFixed(1)]
                                },
                                {
                                    name: customer_chk === 1 ? "신규 접수 고객" : customer_chk === 2 ? "거래가능 고객" : "미팅 비율",
                                    data: customer_chk === 1 ? [data1, checkNaN(companycusdata1 / companyTotal).toFixed(1), checkNaN(companycusdata1 / areaTotal).toFixed(1)] :
                                        customer_chk === 2 ? [data1, checkNaN(companycusdata2 / companyTotal).toFixed(1), checkNaN(companycusdata2 / areaTotal).toFixed(1)] :
                                            [data1, checkNaN(companycusdata3 / companyTotal).toFixed(1), checkNaN(companycusdata3 / areaTotal).toFixed(1)]
                                },
                            ]}
                            options={{
                                // theme: { mode: "dark" },
                                chart: {
                                    height: 180,
                                    type: 'line',
                                    zoom: {
                                        enabled: false
                                    },
                                    toolbar: {
                                        show: false
                                    }
                                },
                                dataLabels: {
                                    enabled: true,
                                    offsetX: 0,
                                    offsetY: -5,
                                    style: {
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        colors: ['#000']
                                    },
                                    background: {
                                        enabled: false
                                    }
                                },
                                stroke: {
                                    curve: 'straight'
                                },
                                title: {
                                    show: false,
                                },
                                grid: {
                                    borderColor: '#ccc',
                                    xaxis: {
                                        lines: {
                                            show: true
                                        }
                                    },
                                    yaxis: {
                                        lines: {
                                            show: false
                                        }
                                    },
                                },
                                legend: {
                                    show: false,
                                },
                                markers: {
                                    size: 5,
                                    strokeColors: ['#5C96ED', '#D81717'],
                                },
                                xaxis: {
                                    categories: [`${memberinfos?.name} ${memberinfos?.rank}(나)`, `우리 사무소\n(1인당 평균)`, `${memberinfos?.compony?.sigungu}\n(1인당 평균)`],
                                    title: {
                                        text: '분류',
                                        offsetX: 315,
                                        offsetY: -50,
                                        style: {
                                            fontSize: '16px',
                                            fontWeight: 400,
                                        }
                                    },
                                    axisTicks: {
                                        show: false
                                    },
                                    // axisBorder: {
                                    //     show: true,
                                    //     color: '#ccc',
                                    //     offsetX: 0,
                                    //     offsetY: 0
                                    // },
                                },
                                yaxis: {
                                    title: {
                                        text: '건수',
                                        rotate: -360,
                                        offsetX: 0,
                                        offsetY: -170,
                                        style: {
                                            fontSize: '16px',
                                            fontWeight: 400,
                                        }
                                    },
                                    labels: {
                                        show: false,
                                    },
                                },
                                colors: ['#5C96ED', '#D81717'],
                            }}
                        />

                        <div className='popup_chart_box'>
                            <div className='weeks_bottom_box'>
                                <img src="./images/icons/chevron-left03.svg" width='24'
                                    onClick={() => {
                                        setweek(moment(week).subtract('1', 'week').day(1).format())
                                    }}
                                />

                                <div className='weeks_title_box'>
                                    <p>{moment(week).day(1).format('YYYY.MM.DD')} ~ {moment(week).day(0).add(7, 'days').format('YYYY.MM.DD')}</p>
                                </div>

                                <img src="./images/icons/chevron-right03.svg" width='24'
                                    onClick={() => {
                                        let weeklast = moment(week).add('1', 'week').day(6);
                                        let sumdate = moment.duration(moment().diff(weeklast)).asDays();
                                        console.log(weeklast, sumdate);
                                        // return;
                                        if (sumdate * 1 < 0) {
                                            dispatch(
                                                open({
                                                    component: '주간 업무 통계는 매주 일요일 자정을 기준으로\n1주일간 업무 통계를 집계합니다.',
                                                    title: '업무 통계 집계중',
                                                    button: "확인",
                                                    titleviewer: true,
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );
                                        } else {
                                            setweek(moment(week).add('1', 'week').day(1).format())
                                        }
                                    }}
                                />
                            </div>

                            {/* <div className='button_div'>
                                <Button
                                    buttonTxt={'전체값 확인'}
                                    className={`searchbutton active`}
                                    styles={{
                                        height: 40,
                                        minHeight: 40,
                                        fontSize: 14
                                    }}
                                    onPress={() => {
                                    }}
                                />
                            </div> */}

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={7} />
                </div>
                <div className='padding32'>
                    <div className='pagetitle fontsize20 bolds'>업무 통계</div>
                    <div className='pagetabs margint20'>
                        <button className='active' onClick={() => { navigate('/Workstat') }}>개인 업무 통계</button>
                        {memberinfos?.level * 1 === 3 &&
                        <button onClick={() => { navigate('/Workstatceo') }}>임직원 업무 통계</button>
                        }
                    </div>
                    <div className='padding32 mypageinputsarea'>
                        {lineChart()}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

